import { useQuery } from '@tanstack/react-query';

import { queries } from '@/features/queries';

/**
 * 코너로지스 정산내역의 결제 상태를 조회합니다. 결제가 필요한 것이 있는지를 확인하는데 사용합니다.
 * @see https://kr-api-qa.acloset.net/shops/swagger/index.html#/Settlements/get_shops__shopID__corner_logis_settlements_payment_status
 */
export const useH_코너로지스_결제_상태_조회_쿼리 = ({
  shopID,
  options,
}: {
  shopID: string;
  options?: {
    enabled?: boolean;
  };
}) => {
  return useQuery({
    ...queries['corner-logis-settlements'].결제_상태_조회({ shopID }),
    ...options,
  });
};
